var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],attrs:{"id":"answer-machine"}},[_c('div',{staticClass:"placeholder"})])}
var staticRenderFns = []

export { render, staticRenderFns }